import { call, put, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";
import { push } from "redux-router";
import validator from "services/validator.js";
import constants from "constants";
import actions from "actions";
import axios from "axios";
import { GET_ADD_TO_CALLENDAR_LINKS } from "../../constants/actions";
import { API_WEBINAR_CALENDAR_LINKS } from "../../constants/api";
import { setAddToCalendarLinks } from "../../actions/webinars";

const {
  addAdminUsersWebinars,
  addAdminUsersWebinarsSessions,
  addAdminUsersNewsletterWebinars,
  addRequestError,
  saveQuestionsOnWebinar,
  saveGallery,
} = actions;

const {
  PUT_GALLERY,
  LOAD_ADMIN_USRES_WEBINARS_SAGA,
  API_WEBINARS_USERS,
  API_LOAD_QUESTIONS_ON_WEBINAR,
  API_WEBINARS_USERS_NEWSLETTER,
  LOAD_ADMIN_USERS_WEBINARS_NEWSLETTER_SAGA,
  GET_QUESTIONS_ON_WEBINAR,
  GET_GALLERY,
  DELETE_GALLERY,
  ADD_GALLERY,
} = constants;

const apiLoadGallery = () =>
  axios.get(`/api/v1/admin/galery_images?page=1&per_page=100`);
const apiDeleteGallery = (id) =>
  axios.post(`/api/v1/admin/galery_images/destroy?image_ids[]=${id}`);
const apiAddGallery = (formData) =>
  axios.post(`/api/v1/admin/galery_images`, formData);
const apiPutGallery = (id, formData) =>
  axios.put(`/api/v1/admin/galery_images/${id}`, formData);
const apiLoadAdminUsersWebinars = (id) =>
  axios.get(`${API_WEBINARS_USERS}/${id}`);

const apiLoadAdminUsersWebinarsNewsletter = (id, page, query) =>
  axios.get(`${API_WEBINARS_USERS_NEWSLETTER}/${id}`, {
    params: {
      page,
      per_page: 50,
      ...query,
    },
  });
const apiLoadQuestionOnWebinar = (id) =>
  axios.get(`${API_LOAD_QUESTIONS_ON_WEBINAR}/${id}`);

const apiGetAddToCalendarLinks = (webinarId) =>
  axios.get(`${API_WEBINAR_CALENDAR_LINKS}/${webinarId}`);

function* loadAdminUsersWebinars({ webinarId }) {
  try {
    const response = yield call(apiLoadAdminUsersWebinars, webinarId);
    const users = response.data.users;
    yield put(addAdminUsersWebinars(users));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* loadAdminUsersWebinarsNewsletter({ webinarId, page = 1 }) {
  try {
    const response = yield call(
      apiLoadAdminUsersWebinarsNewsletter,
      webinarId,
      page
    );
    const { users, count, total_pages } = response.data;
    yield put(addAdminUsersNewsletterWebinars(users, count, total_pages));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}
function* getQuestionsOnWebinar({ payload: { id, page } }) {
  try {
    const response = yield call(apiLoadQuestionOnWebinar, id);
    yield put(saveQuestionsOnWebinar(response.data.questions));
  } catch (e) {
    console.log(e);
    yield put(addRequestError(e));
  }
}
function* getGallery() {
  try {
    const response = yield call(apiLoadGallery);
    const { galery_images } = response.data;
    yield put(saveGallery(galery_images));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}
function* deleteGallery({ payload: { id } }) {
  try {
    const deletion = yield call(apiDeleteGallery, id);
    const response = yield call(apiLoadGallery);
    const { galery_images } = response.data;
    yield put(saveGallery(galery_images));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}
function* addGallery(data) {
  try {
    const formData = new FormData();
    formData.append(
      "[galery_image][title]",
      data.payload.image.name.split(".").pop()
    );
    formData.append("[galery_image][is_default]", false);
    formData.append("[galery_image][image]", data.payload.image);
    const creation = yield call(apiAddGallery, formData);
    const response = yield call(apiLoadGallery);
    const { galery_images } = response.data;
    yield put(saveGallery(galery_images));
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}
function* putGallery({ payload: { id, data } }) {
  try {
    const formData = new FormData();
    for (let i in data) {
      formData.append(`[galery_image][${i}]`, data[i]);
    }
    const putting = yield call(apiPutGallery, id, formData);
    const response = yield call(apiLoadGallery);
    const { galery_images } = response.data;
    yield put(saveGallery(galery_images));
  } catch (e) {
    yield put(addRequestError(e));
  }
}

function* getAddToCalendarLinks({ payload }) {
  try {
    const { webinarId } = payload;
    const response = yield call(apiGetAddToCalendarLinks, webinarId);
    const { links } = response.data;
    yield put(setAddToCalendarLinks(links));
  } catch (e) {
    yield put(addRequestError(e));
  }
}

function* __loadAdminUsersWebinars() {
  yield takeEvery(LOAD_ADMIN_USRES_WEBINARS_SAGA, loadAdminUsersWebinars);
}

function* __loadAdminUsersWebinarsNewsletter() {
  yield takeEvery(
    LOAD_ADMIN_USERS_WEBINARS_NEWSLETTER_SAGA,
    loadAdminUsersWebinarsNewsletter
  );
}
function* __getQuestionsOnWebinar() {
  yield takeEvery(GET_QUESTIONS_ON_WEBINAR, getQuestionsOnWebinar);
}
function* __getGallery() {
  yield takeEvery(GET_GALLERY, getGallery);
}
function* __deleteGallery() {
  yield takeEvery(DELETE_GALLERY, deleteGallery);
}

function* __addGallery() {
  yield takeEvery(ADD_GALLERY, addGallery);
}
function* __putGallery() {
  yield takeEvery(PUT_GALLERY, putGallery);
}

function* __getAddToCalendarLinks() {
  yield takeEvery(GET_ADD_TO_CALLENDAR_LINKS, getAddToCalendarLinks);
}

export {
  __loadAdminUsersWebinars,
  __loadAdminUsersWebinarsNewsletter,
  __getQuestionsOnWebinar,
  __getGallery,
  __deleteGallery,
  __addGallery,
  __putGallery,
  __getAddToCalendarLinks,
};



// WEBPACK FOOTER //
// ./src/sagas/admin/webinars.js